var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C10 17.4477 10.3582 17 10.8 17H21.2C21.6418 17 22 17.4477 22 18C22 18.5523 21.6418 19 21.2 19H10.8C10.3582 19 10 18.5523 10 18Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18C5 17.4477 5.44549 17 5.99502 17H6.00498C6.55451 17 7 17.4477 7 18C7 18.5523 6.55451 19 6.00498 19H5.99502C5.44549 19 5 18.5523 5 18Z",
    fill: "#3B3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 11.4477 10.3582 11 10.8 11H21.2C21.6418 11 22 11.4477 22 12C22 12.5523 21.6418 13 21.2 13H10.8C10.3582 13 10 12.5523 10 12Z",
    fill: "#3B3B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 11.4477 5.44549 11 5.99502 11H6.00498C6.55451 11 7 11.4477 7 12C7 12.5523 6.55451 13 6.00498 13H5.99502C5.44549 13 5 12.5523 5 12Z",
    fill: "#3B3B3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7 5.44772 7.44772 5 8 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H8C7.44772 7 7 6.55228 7 6Z",
    fill: "#3B3B3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 5.44772 2.44549 5 2.99502 5H3.00498C3.55451 5 4 5.44772 4 6C4 6.55228 3.55451 7 3.00498 7H2.99502C2.44549 7 2 6.55228 2 6Z",
    fill: "#3B3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.a42fe240.svg";
export { ForwardRef as ReactComponent };